import { ToastAlertTypes } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';

export const messageError = '―';

export const SKELETON_PROPS = {
  w: { base: '120px', sm: '260px', lg: 'full' } as const,
  h: Spacing['inline.xxxs'],
  borderRadius: BoxRadius.sm,
  endColor: Color['brand.primary.lightest'],
};

export const LOADING_COL_OVERRIDES = [
  { idx: 1, flex: 1.5 },
  { idx: 3, flex: 1.5 },
  { idx: 6, flex: 0.5, isIcon: true },
];

export const LOADING_OFFERS_TOTAL_COLS = 7;
export const LOADING_OFFERS_TOTAL_ROWS = 9;

export const screenName = 'resgate-boleta-lote';

export const errorExportRedeemSpreadsheetSentMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao exportar os registros enviados,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const errorExportRedeemSpreadsheetErrorMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao exportar os registros com erro,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const errorSendRedeemOffersMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao concluir o envio da boleta,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const errorCancelRedeemOfferMessage: [ToastAlertTypes.Type, string, string] = [
  'error',
  'Opa! Algo parece errado.',
  'Ocorreu um erro ao concluir esta solicitação,\nverifique sua conexão com a internet e\ntente novamente em instantes.',
];

export const cancelingRedeemOffersLoadingMessage = {
  title: 'Aguarde enquanto estamos cancelando sua cesta. ',
  description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
};

export const cancelingRedeemOffersToastMessageSuccess = [
  'success',
  'Tudo certo!',
  'A cesta foi cancelada com sucesso.',
] as const;

export const sendingRedeemOffersLoadingMessage = {
  title: 'Aguarde enquanto estamos enviando a sua cesta.',
  description: 'Este processo pode levar alguns segundos, não saia desta pagina.',
};

export const sendingRedeemOffersToastMessageSuccess = [
  'success',
  'Tudo certo!',
  'A cesta foi enviada com sucesso.',
] as const;
